import { render } from "./headerComponent.vue?vue&type=template&id=10a7f701&scoped=true"
import script from "./headerComponent.vue?vue&type=script&lang=js"
export * from "./headerComponent.vue?vue&type=script&lang=js"

import "./headerComponent.vue?vue&type=style&index=0&id=10a7f701&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\HP\\Desktop\\Proyectos Vue.js\\version-produccion-iquela\\Dashboard_usuarios\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a7f701"]])

export default __exports__